export const checkForVersionUpdates = async () => {
    try {
        const response = await fetch('/version.json', { cache: 'no-cache' });
        const data = await response.json();
        const currentVersion = localStorage.getItem('app_version');

        if (currentVersion && currentVersion !== data.version) {
            // Store the current URL before refreshing
            localStorage.setItem(
                'last_visited_page',
                window.location.pathname + window.location.search
            );

            localStorage.setItem('app_version', data.version);
            window.location.href = window.location.origin + '?reload=' + new Date().getTime();
        } else {
            localStorage.setItem('app_version', data.version);
        }
    } catch (error) {
        console.error('Error checking for updates:', error);
    }
};
